import { createFileRoute } from '@tanstack/react-router';
import { HelpCentre } from '../../features/help/HelpCentre';

/** Full help centre (all three guides, sidebar ToC, hash deep-linking — see
 * features/help/HelpCentre.tsx). Deliberately NOT role-gated, unlike most
 * route groups (contrast settings.tsx's ADMIN-only nav gate): every role,
 * including READ_ONLY, gets full documentation access — same "visible to
 * everyone" treatment Search gets in UTILITY_ITEMS and Reports gets in
 * NAV_SECTIONS (lib/nav.ts). */
export const Route = createFileRoute('/_authenticated/help')({
  component: HelpCentre,
});
